export default __webpack_public_path__ + "static/fabric-style-3-3a1471f2da0e2229237fe7e560db6c0f.png";